var React = require('react');

function Twitter (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M45,1H5C2.8,1,1,2.8,1,5v40c0,2.2,1.8,4,4,4h40c2.2,0,4-1.8,4-4V5C49,2.8,47.2,1,45,1z","fill":"#2CA7E0","key":0}),React.createElement("path",{"d":"M40,16.2c-1.1,0.5-2.8,1.1-4,1.3c1.3-0.8,2.5-2.6,3-4c-1,0.6-2.1,1.4-3.2,1.8L35,14.5  c-1.1-1.2-2.2-2-4-2c-3.4,0-6,2.6-6,6c0,0.4,0,0.7,0.1,1l-0.1,0c-6,0-10-1.3-13-5c-0.5,0.9-1,1.9-1,3c0,2.1,1.3,3.9,3,5  c-1,0-2.2-0.5-3-1c0,3,4.2,6.4,7,7c-1,1-4.6,0.1-5,0c0.8,2.4,3.3,3.9,6,4c-2.1,1.6-4.6,2.5-7.5,2.5c-0.5,0-1,0-1.5-0.1  c2.7,1.7,6.5,2.6,10,2.6c11.3,0,17-8.9,17-17c0-0.3,0-0.7,0-1C38.2,18.6,39.2,17.4,40,16.2z","fill":"#FFFFFF","id":"Brid_1_","key":1})]);
}

Twitter.defaultProps = {"enableBackground":"new 0 0 50 50","id":"Layer_1","version":"1.1","viewBox":"0 0 50 50","xmlSpace":"preserve"};

module.exports = Twitter;

Twitter.default = Twitter;
